import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      userSelect: "none",
      cursor: "pointer",
      backgroundColor: theme.goal.deposits.background,
      padding: constants.divPadding,
      borderRadius: constants.radius.view,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    text: {
      color: theme.goal.deposits.text,
      flexGrow: 1,
    },
    icon: {
      marginRight: spacing.m,
    },
  };

  return styles;
};
